    //
    // Books => when Child Page of a Books is displayed we scroll down to content area below Masthead
    //

    var fn_masthead_node_scroll = function () {
      var page = $('body').hasClass('page-node-type-need');

      var headerHeight = $('.header').outerHeight();
      var mastHeight = $('.masthead').outerHeight();
      var block_alert = $(".block-bdt-alert");


      if ($(block_alert).length) {
        var alertHeight = $(block_alert).outerHeight();
      } else {
        var alertHeight = 0;
      }

      // Delaying Opening of Collapse coz of IE
      $(window).on("load", function () {
        $.ready.then(function () {
            //
            if (page) {
                // If TRUE we slide down one screen
                $('html, body').animate({
                  scrollTop: (alertHeight + headerHeight + mastHeight + 100)
                }, 860);
            }
            //
          });
      })
      //

  };
  //

